/**
 * PoppinPay API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The GiftCardBalanceResultModel model module.
* @module model/GiftCardBalanceResultModel
* @version 1.0.0
*/
export default class GiftCardBalanceResultModel {
    /**
    * Constructs a new <code>GiftCardBalanceResultModel</code>.
    * @alias module:model/GiftCardBalanceResultModel
    * @class
    */

    constructor() {
        
        
        
    }

    /**
    * Constructs a <code>GiftCardBalanceResultModel</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/GiftCardBalanceResultModel} obj Optional instance to populate.
    * @return {module:model/GiftCardBalanceResultModel} The populated <code>GiftCardBalanceResultModel</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new GiftCardBalanceResultModel();
                        
            
            if (data.hasOwnProperty('GiftCardId')) {
                obj['GiftCardId'] = ApiClient.convertToType(data['GiftCardId'], 'String');
            }
            if (data.hasOwnProperty('BalanceAmount')) {
                obj['BalanceAmount'] = ApiClient.convertToType(data['BalanceAmount'], 'Number');
            }
        }
        return obj;
    }

    /**
    * @member {String} GiftCardId
    */
    'GiftCardId' = undefined;
    /**
    * @member {Number} BalanceAmount
    */
    'BalanceAmount' = undefined;




}
